import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import { Tooltip, Stack } from "@mui/material";
import PageviewIcon from "@mui/icons-material/Pageview";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
// import ExpandLess from "@mui/icons-material/ExpandLess";
// import ExpandMore from "@mui/icons-material/ExpandMore";
// import Collapse from "@mui/material/Collapse";
import TocIcon from "@mui/icons-material/Toc";
import { useSnackbar } from "notistack";

export default function ExportDialogList(props) {
  const { enqueueSnackbar } = useSnackbar();
  // const [open, setOpen] = React.useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  const onSampleClick = (sample) => {
    enqueueSnackbar(sample, {
      anchorOrigin: {
        vertical: "top",
        horizontal: "center",
      },
      variant: "info",
    });
  };

  return (
    <List
      sx={{ width: "100%", bgcolor: "background.paper" }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <Typography id="nested-list-subheader">
          For each section, check fields to include in export or select saved template
        </Typography>
      }
    >
      {props.reportSections.map((section, idx) => [
        <ListItemButton
          key={idx}
          //  onClick={handleClick}
        >
          <ListItemIcon>
            <TocIcon />
          </ListItemIcon>

          {/* onClick={() =>
            props.handleCheckedSection(section.name, !section.checked)
          } */}
          <ListItemText primary={section.name} />
          {/* {open ? <ExpandLess /> : <ExpandMore />} */}

          <Switch
            edge="end"
            defaultChecked
            onChange={(e) =>
              props.handleCheckedSection(section.name, e.target.checked)
            }
            // checked={checked.includes("wifi")}
          />
        </ListItemButton>,
        // <Collapse key={idx + 1} in={open} timeout="auto" unmountOnExit>
        // ,
        section.isChecked ? (
          <List key={idx + 2} component="div" disablePadding>
            {section.fields
              .sort((a, b) => a.order - b.order)
              .map((field, fidx) => (
                <ListItem
                  key={fidx}
                  sx={{ pl: 4 }}
                  secondaryAction={
                    <Stack
                      sx={{ flexGrow: 1, display: { xs: "none", sm: "flex" } }}
                      direction="row"
                      spacing={1}
                    >
                      {field.name !== "Show Files?" &&
                        field.name !== "Show Pictures?" && (
                          <Tooltip title="View Sample Data">
                            <IconButton
                              edge="end"
                              aria-label="comments"
                              onClick={() => onSampleClick(field.sample)}
                            >
                              <PageviewIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      <Tooltip title="Move up">
                        <IconButton
                          edge="end"
                          aria-label="Move up"
                          onClick={() =>
                            props.onMoveClick(section.name, fidx, -1)
                          }
                        >
                          <ArrowUpward />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Move Down">
                        <IconButton
                          edge="end"
                          aria-label="Move down"
                          onClick={() =>
                            props.onMoveClick(section.name, fidx, 1)
                          }
                        >
                          <ArrowDownward />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  }
                >
                  <ListItemIcon>
                    <Checkbox
                      onChange={(e) =>
                        props.handleChecked(
                          section.name,
                          field.name,
                          e.target.checked,
                        )
                      }
                      checked={field.checked}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={field.name}
                    secondary={
                      <Stack
                        sx={{
                          flexGrow: 1,
                          display: { xs: "flex", sm: "none" },
                        }}
                        direction="row"
                        spacing={1}
                      >
                        {field.name !== "Show Files?" &&
                          field.name !== "Show Pictures?" && (
                            <Tooltip title="View Sample Data">
                              <IconButton
                                edge="end"
                                aria-label="comments"
                                onClick={() => onSampleClick(field.sample)}
                              >
                                <PageviewIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        <Tooltip title="Move up">
                          <IconButton
                            disabled={fidx === 0}
                            edge="end"
                            aria-label="Move up"
                            onClick={() =>
                              props.onMoveClick(section.name, fidx, -1)
                            }
                          >
                            <ArrowUpward />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Move Down">
                          <IconButton
                            edge="end"
                            disabled={fidx === section.fields.length - 1}
                            aria-label="Move down"
                            onClick={() =>
                              props.onMoveClick(section.name, fidx, 1)
                            }
                          >
                            <ArrowDownward />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    }
                  />
                </ListItem>
              ))}
          </List>
        ) : null,

        // </Collapse>,
      ])}
    </List>
  );
}
